/**
 * Store global da seleção de tenant feita pelo super_admin — TH-54656.
 *
 * Paridade com o mobile (DataStoreTenantSelection em
 * `apps/mobile-android/.../data/local/TenantSelectionDataStore.kt`).
 * Apenas super_admin entra no fluxo "selecionar cliente antes de operar".
 * Usuários tenant-scoped (tenant_admin, store_manager, operator) NUNCA
 * mexem com este store — o tenant_id deles vem do JWT.
 *
 * Persistência: zustand persist middleware → localStorage. A chave
 * `selection` guarda `{ id, name }` (mesmo schema do mobile) ou `null`.
 * Backend (TH-54654) lê `X-Tenant-Id` apenas quando role=super_admin.
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface TenantSelection {
  id: string;
  name: string;
}

interface TenantSelectionState {
  selection: TenantSelection | null;
  select: (selection: TenantSelection) => void;
  clear: () => void;
}

export const useTenantSelectionStore = create<TenantSelectionState>()(
  persist(
    (set) => ({
      selection: null,
      select: (selection) => set({ selection }),
      clear: () => set({ selection: null }),
    }),
    {
      name: "priceshow:tenant-selection",
      version: 1,
    },
  ),
);

/**
 * Leitura síncrona fora de componentes React. Usado pelo apiClient
 * (interceptor de fetch) para injetar `X-Tenant-Id` em cada request
 * sem depender de hook React.
 */
export function getSelectedTenantId(): string | null {
  return useTenantSelectionStore.getState().selection?.id ?? null;
}
